import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import useTranslate from '../../Hooks/useTranslate';
import useMobileNavigation from './useMobileNavigation';

/**
 * MobileTabBar — the 5-tab bottom navigation (see MOBILE_PLAN.md §C). Uses MUI
 * BottomNavigation for selection state, labels and a11y; wrapped in a Paper so
 * it inherits the themed surface and rounds its top corners. The selected tab
 * shows the mockup's pill behind its icon (theme.custom.mobile.activePill).
 */
const MobileTabBar = function MobileTabBar() {
  const theme = useTheme();
  const translate = useTranslate();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { tabs, findActiveTab } = useMobileNavigation();
  const activeKey = findActiveTab(pathname)?.key ?? false;
  const { mutedColor, activePill, tabBarHeight } = theme.custom.mobile;

  const handleChange = (event, key) => {
    const tab = tabs.find((item) => item.key === key);
    if (tab) navigate(tab.path);
  };

  return (
    <Paper id="mobile-tab-bar-paper" sx={{ borderRadius: '18px 18px 0 0' }}>
      <BottomNavigation
        value={activeKey}
        onChange={handleChange}
        showLabels
        sx={{
          borderRadius: '18px 18px 0 0',
          height: tabBarHeight,
          alignItems: 'flex-start',
          pt: 1,
        }}
      >
        {tabs.map((tab) => {
          const { Icon } = tab;
          const selected = tab.key === activeKey;
          return (
            <BottomNavigationAction
              key={tab.key}
              value={tab.key}
              label={translate(tab.labelKey)}
              icon={
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: selected ? 2.25 : 0,
                    py: 0.4,
                    borderRadius: '16px',
                    bgcolor: selected ? activePill : 'transparent',
                    transition: 'background-color .2s ease',
                  }}
                >
                  <Icon sx={{ fontSize: 26 }} />
                </Box>
              }
              sx={{
                minWidth: 0,
                color: mutedColor,
                '&.Mui-selected': { color: 'primary.main' },
                '& .MuiBottomNavigationAction-label': {
                  fontSize: 11,
                  fontWeight: 500,
                  mt: 0.4,
                },
                '& .MuiBottomNavigationAction-label.Mui-selected': {
                  fontSize: 11,
                  fontWeight: 600,
                },
              }}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileTabBar;
